import { CustomModal, ItemHelpButton } from "../../../components";
import { useHelpButtonReducer } from "../../../hooks/home/index";
// import { AddTraining } from "./AddTraining";
// import { AddStudents } from "./AddStudents";
// import { AddResults } from "./AddResults";
// import { AddGroup } from "./AddGroup";
import ItemDowloadCSV from "../../../components/ItemDowloadCSV";
import { useSelector } from "react-redux";
import { AddGroupV2 } from "./AddGroupV2";
import { AddUser } from "./AddUser";
import { AddUsersByFile } from "./AddUsersByFile";
import ItemDowloadCSVSimiAR from "../../../components/ItemDowloadCSVSimiAR";

export const HelpButtons = () => {
    const { setAddStudentModal, setSubjectModal, setUpdateFileModal, state } = useHelpButtonReducer();
    const { groups, proyectSelected } = useSelector(state => state.vrlSlice)
    // const { responses, proyectSelected,  } = useSelector((state) => state.vrlSlice);
    // const { proyectSelected } = useSelector((state) => state.vrlSlice);

    return (
        <div className="h-full w-[69px] flex flex-col items-center pt-[72px]">
            {/* <ItemHelpButton
                key={"addTraining"}
                title={"Agregar Capacitación"}
                icon={<PlusOutlined className="text-white" />}
                openModal={setTrainingModal}
            />
            <CustomModal
                key={"addTraining-modal"}
                isVisible={state.addTraining}
                close={setTrainingModal}
                title={"Agregar Capacitación"}
                width={"430px"}
                height={"444px"}
            >
                <AddTraining close={setTrainingModal} />
            </CustomModal> */}
            {/* <CustomModal
                key={"AddGroup"}
                isVisible={state.addSubject}
                close={setSubjectModal}
                title={`Agregar grupo a ${proyectSelected.name}`}
                width={"430px"}
                height={"192px"}
                >
                <AddGroup close={setSubjectModal} />
                </CustomModal> */}
            <ItemHelpButton disabled={false}
                key={"AddGroup-it"}
                title={`Agregar grupo`}
                icon={
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M20 6.25V9.25M20 9.25V12.25M20 9.25H23M20 9.25H17" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M17.7488 17.97C17.7449 16.8366 17.4185 15.7268 16.8078 14.772C16.2657 13.9218 15.5179 13.222 14.6336 12.7375C13.7493 12.253 12.7571 11.9993 11.7488 12C10.7406 11.9995 9.74859 12.2532 8.86449 12.7377C7.9804 13.2223 7.23277 13.9219 6.69076 14.772M17.7478 17.969L17.7488 18C17.7488 18.225 17.7368 18.447 17.7118 18.666C15.8971 19.7071 13.8409 20.2533 11.7488 20.25C9.57876 20.25 7.54176 19.674 5.78576 18.666C5.76006 18.4346 5.7477 18.2019 5.74876 17.969M5.74876 17.969C4.48239 18.0763 3.20867 17.9137 2.00976 17.492C1.96412 16.9276 2.07916 16.3617 2.34159 15.8599C2.60403 15.3581 3.00313 14.9408 3.49277 14.6563C3.9824 14.3718 4.54256 14.2317 5.10848 14.2521C5.67441 14.2726 6.22297 14.4528 6.69076 14.772M5.74876 17.969C5.75236 16.8357 6.08039 15.7269 6.69076 14.772M14.7488 6C14.7488 6.79565 14.4327 7.55871 13.8701 8.12132C13.3075 8.68393 12.5444 9 11.7488 9C10.9531 9 10.1901 8.68393 9.62744 8.12132C9.06483 7.55871 8.74876 6.79565 8.74876 6C8.74876 5.20435 9.06483 4.44129 9.62744 3.87868C10.1901 3.31607 10.9531 3 11.7488 3C12.5444 3 13.3075 3.31607 13.8701 3.87868C14.4327 4.44129 14.7488 5.20435 14.7488 6ZM7.24876 9C7.24876 9.29547 7.19057 9.58806 7.07749 9.86104C6.96442 10.134 6.79869 10.3821 6.58975 10.591C6.38082 10.7999 6.13278 10.9657 5.8598 11.0787C5.58682 11.1918 5.29424 11.25 4.99876 11.25C4.70329 11.25 4.41071 11.1918 4.13773 11.0787C3.86474 10.9657 3.61671 10.7999 3.40777 10.591C3.19884 10.3821 3.03311 10.134 2.92004 9.86104C2.80696 9.58806 2.74876 9.29547 2.74876 9C2.74876 8.40326 2.98582 7.83097 3.40777 7.40901C3.82973 6.98705 4.40203 6.75 4.99876 6.75C5.5955 6.75 6.1678 6.98705 6.58975 7.40901C7.01171 7.83097 7.24876 8.40326 7.24876 9Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                } openModal={setSubjectModal} />
            <CustomModal
                key={"AddGroup"}
                isVisible={state.addSubject}
                close={setSubjectModal}
                title={`Agregar grupo`}
                width={"430px"}
                height={"510px"}
            >
                <AddGroupV2 close={setSubjectModal} />
            </CustomModal>

            <ItemHelpButton
                key={"addStudents"}
                disabled={!(groups.length > 0)}
                title={"Agregar usuario"}
                icon={
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M18 7.5V10.5M18 10.5V13.5M18 10.5H21M18 10.5H15M12.75 6.375C12.75 7.27011 12.3944 8.12855 11.7615 8.76149C11.1285 9.39442 10.2701 9.75 9.375 9.75C8.47989 9.75 7.62145 9.39442 6.98851 8.76149C6.35558 8.12855 6 7.27011 6 6.375C6 5.47989 6.35558 4.62145 6.98851 3.98851C7.62145 3.35558 8.47989 3 9.375 3C10.2701 3 11.1285 3.35558 11.7615 3.98851C12.3944 4.62145 12.75 5.47989 12.75 6.375ZM3 19.235V19.125C3 17.4342 3.67165 15.8127 4.86719 14.6172C6.06274 13.4216 7.68424 12.75 9.375 12.75C11.0658 12.75 12.6873 13.4216 13.8828 14.6172C15.0784 15.8127 15.75 17.4342 15.75 19.125V19.234C13.8255 20.3931 11.6206 21.0038 9.374 21C7.043 21 4.862 20.355 3 19.234V19.235Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                }
                openModal={setAddStudentModal}
            />
            <CustomModal
                key={"AddUsser"}
                isVisible={state.addStudents}
                close={setAddStudentModal}
                title={`Agregar Usuario`}
                width={"430px"}
                height={"470px"}
            >
                <AddUser close={setAddStudentModal} />
            </CustomModal>


            <ItemHelpButton disabled={!(groups.length > 0)}
                key={"upload"}
                title={"Subir archivo"}
                icon={<svg xmlns="http://www.w3.org/2000/svg" width="18" height="22" viewBox="0 0 18 22" fill="none">
                    <path d="M16.5 13.25V10.625C16.5 9.72989 16.1444 8.87145 15.5115 8.23851C14.8786 7.60558 14.0201 7.25 13.125 7.25H11.625C11.3266 7.25 11.0405 7.13147 10.8295 6.9205C10.6185 6.70952 10.5 6.42337 10.5 6.125V4.625C10.5 3.72989 10.1444 2.87145 9.51149 2.23851C8.87855 1.60558 8.02011 1.25 7.125 1.25H5.25M12 13.25L9 10.25M9 10.25L6 13.25M9 10.25V16.25M7.5 1.25H2.625C2.004 1.25 1.5 1.754 1.5 2.375V19.625C1.5 20.246 2.004 20.75 2.625 20.75H15.375C15.996 20.75 16.5 20.246 16.5 19.625V10.25C16.5 7.86305 15.5518 5.57387 13.864 3.88604C12.1761 2.19821 9.88695 1.25 7.5 1.25Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                </svg>
                }
                openModal={setUpdateFileModal} />
            <CustomModal
                key={"upload-modal"}
                isVisible={state.updateFile}
                close={setUpdateFileModal}
                title={`Subir Archivo`}
                width={"424px"}
                height={"490px"}
            >
                <AddUsersByFile close={setUpdateFileModal} />
            </CustomModal>
            {/* <ItemHelpButton disabled={!(groups.length > 0)} key={"upload"} title={"Subir archivo"} icon={<UploadOutlined className="text-white" />} openModal={setUpdateFileModal} />
            <CustomModal
                key={"upload-modal"}
                isVisible={state.updateFile}
                close={setUpdateFileModal}
                title={`Agregar resultados a ${proyectSelected.name}`}
                width={"430px"}
                height={"520px"}
            >
                <UpdateCampaing close={setUpdateFileModal} />
            </CustomModal> */}

            {/* <ItemHelpButton
                key={"addResults"}
                title={"Agregar resultados"}
                icon={<FileAddOutlined className="text-white" />}
                openModal={setResultModal}
            />
            <CustomModal
                key={"addresults"}
                isVisible={state.addResults}
                close={setResultModal}
                title={"Agregar resultados"}
                width={"430px"}
                height={"520px"}
            >
                <AddResults close={setResultModal} />
            </CustomModal> */}
            {
                proyectSelected._id !== "66155e601e91fe7bde671941" &&
            <ItemDowloadCSV
                key={"exportCsv"}
                disabled={!(groups.length > 0)}
                title={"Exportar .csv"}
                icon={
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M19.5 14.25V11.625C19.5 10.7299 19.1444 9.87145 18.5115 9.23851C17.8786 8.60558 17.0201 8.25 16.125 8.25H14.625C14.3266 8.25 14.0405 8.13147 13.8295 7.9205C13.6185 7.70952 13.5 7.42337 13.5 7.125V5.625C13.5 4.72989 13.1444 3.87145 12.5115 3.23851C11.8785 2.60558 11.0201 2.25 10.125 2.25H8.25M9 14.25L12 17.25M12 17.25L15 14.25M12 17.25V11.25M10.5 2.25H5.625C5.004 2.25 4.5 2.754 4.5 3.375V20.625C4.5 21.246 5.004 21.75 5.625 21.75H18.375C18.996 21.75 19.5 21.246 19.5 20.625V11.25C19.5 8.86305 18.5518 6.57387 16.864 4.88604C15.1761 3.19821 12.8869 2.25 10.5 2.25Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                }
            />
            }
            {
                proyectSelected._id === "66155e601e91fe7bde671941" &&
                <ItemDowloadCSVSimiAR
                    key={"exportCsv"}
                    disabled={!(groups.length > 0)}
                    title={"Exportar AR.csv"}
                    icon={
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <path d="M19.5 14.25V11.625C19.5 10.7299 19.1444 9.87145 18.5115 9.23851C17.8786 8.60558 17.0201 8.25 16.125 8.25H14.625C14.3266 8.25 14.0405 8.13147 13.8295 7.9205C13.6185 7.70952 13.5 7.42337 13.5 7.125V5.625C13.5 4.72989 13.1444 3.87145 12.5115 3.23851C11.8785 2.60558 11.0201 2.25 10.125 2.25H8.25M9 14.25L12 17.25M12 17.25L15 14.25M12 17.25V11.25M10.5 2.25H5.625C5.004 2.25 4.5 2.754 4.5 3.375V20.625C4.5 21.246 5.004 21.75 5.625 21.75H18.375C18.996 21.75 19.5 21.246 19.5 20.625V11.25C19.5 8.86305 18.5518 6.57387 16.864 4.88604C15.1761 3.19821 12.8869 2.25 10.5 2.25Z" stroke="white" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                    }
                />
            }
            {/* <CustomModal key={"exportcsv"} isVisible={state.exportCsv} close={setCsvModal} title="Exportar .csv" width={"430px"} height={"140px"}> */}
            {/* <ExportCsv close={setCsvModal} /> */}
            {/* </CustomModal> */}
        </div>
    );
};
